export default __webpack_public_path__ + "static/media/granville12.7012de0e.jpg";